import Axios from 'axios';

export const BASE_URL_TRUSTNET = process.env.REACT_APP_BASE_URL_TRUSTNET;
export const BASE_URL_PICLOQ_CHAT = process.env.REACT_APP_BASE_URL_PICLOQ_CHAT;
export const FROM_WEB_TO_SERVER_CHANNEL =
  process.env.REACT_APP_FROM_WEB_TO_SERVER_CHANNEL;
export const FROM_SERVER_TO_WEB_CHANNEL =
  process.env.REACT_APP_FROM_SERVER_TO_WEB_CHANNEL;
export const FROM_SERVER_TO_DASHBOARD_CHANNEL =
  process.env.REACT_APP_FROM_SERVER_TO_DASHBOARD_CHANNEL;

export const makeRequest = async (method, path, body = {}) => {
  let url = `${BASE_URL_TRUSTNET}/${path}`;
  let res = await Axios[method](url, body);
  return res;
};

export const makeRequestBySelfiID = async (method, path, body = {}) => {
  let url = `${BASE_URL_PICLOQ_CHAT}/${path}`;
  let res = await Axios[method](url, body, {
    headers: {
      Authorization: 'ZPDDxHSOUpWaW6ECWenK',
    },
  });
  return res;
};
